import React, { useState } from 'react';
import LinkButton from '../linkButton/linkButton';

type Props = {
  links: any[];
  getLinkClass?: (...args: any[]) => any;
  className: string;
  debounceMilliseconds: number;
};

const useClickDebounce = (
  milliseconds: number
): [boolean, (event: Event) => void] => {
  const [clicked, setClicked] = useState(false);
  const [timeoutId, setTimeoutId] = useState<any>(null);

  const debounceEvent = (event: Event) => {
    event.preventDefault();

    setClicked(true);

    if (timeoutId) clearTimeout(timeoutId);

    const newTimeoutId = setTimeout(() => {
      setClicked(false);
    }, milliseconds);

    setTimeoutId(newTimeoutId);
  };

  return [clicked, debounceEvent];
};

const LinkGroup = (props: Props) => {
  const { links, getLinkClass, className, debounceMilliseconds } = props;
  const [clicked, debounceEvent] = useClickDebounce(debounceMilliseconds);

  const handleClick = (e: any, route: string) => {
    debounceEvent(e);

    if (clicked) return;

    document.location.href = route; // redirect
  };

  return (
    <div className={className}>
      {links.map((link: any) => (
        <LinkButton
          key={link.label}
          data={link}
          linkClass={getLinkClass?.(link)}
          onClick={handleClick}
        />
      ))}
    </div>
  );
};

export default LinkGroup;
